import { AppShell, CenteredCard } from '@/pages/external/components/shell'

/**
 * Shared status surfaces for the OAuth SSO pages, built on the themed AppShell so they match
 * the login / consent / checkout surfaces. `logoLinksToDashboard` is false everywhere here:
 * navigating away mid-flow would strand the partner handshake.
 */

export function OAuthLoading({ message = 'Loading…' }: { message?: string }) {
  return (
    <AppShell logoLinksToDashboard={false}>
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-4rem)]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[color:var(--accent)] mb-4" />
        <p className="text-[color:var(--ink-soft)] text-sm">{message}</p>
      </div>
    </AppShell>
  )
}

export function OAuthError({
  title = 'Something went wrong',
  message,
  action,
}: {
  title?: string
  message: string
  /** Optional call-to-action rendered under the message (e.g. a break-out link). */
  action?: React.ReactNode
}) {
  return (
    <AppShell logoLinksToDashboard={false}>
      <CenteredCard>
        <div className="flex flex-col items-center text-center gap-y-3">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center"
            style={{ background: 'color-mix(in srgb, var(--negative) 12%, transparent)' }}
            aria-hidden
          >
            <svg className="w-6 h-6 text-[color:var(--negative)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              />
            </svg>
          </div>
          <h1 className="text-lg font-[family:var(--display-font)] font-[number:var(--display-weight)] text-[color:var(--ink)]">
            {title}
          </h1>
          <p className="text-[color:var(--ink-soft)] text-sm">{message}</p>
          {action && <div className="w-full mt-2">{action}</div>}
        </div>
      </CenteredCard>
    </AppShell>
  )
}
